let timing = window.performance && window.performance.timing || null
export default {
    data() {
        return {
            Performance: [],
            childNum: 1,
            containerNum: 0,
            totalChildNum: 1,
            pageInfo: window.pageInfo && JSON.parse(window.pageInfo.content),
        }
    },
    watch: {
        Performance() {
            if (
                this.Performance.length === this.totalChildNum &&
                this.containerNum !== 0 &&
                this.$attrs['data-node-id'] !== 'root'
            ) {
                this.website_findParentNode(this.$parent && this.$parent.$parent)
            } else if (
                this.Performance.length === this.totalChildNum &&
                this.$attrs['data-node-id'] === 'root'
            ) {
                let maxTime = 0
                let minTime = 0
                this.Performance.forEach((item) => {
                    maxTime = Math.max(item.t, maxTime)
                    if (item.nt !== 'mc-baseContainer') {
                        minTime = Math.min(item.t, minTime)
                    }
                })

                window.$all_components_loaded = true

                //组件加载性能埋点
                this.allBridge
                    .allEventTrack({
                        category: "alle_page",
                        action: 'all_components_loaded_event',
                        value: {
                            totalCostTime: maxTime,
                            firstCostTime: minTime,
                            costTimeDetails: this.Performance,
                        },
                    })
                    .finally(() => {
                    })
                //onload埋点
                window.addEventListener('load', () => {
                    this.allBridge
                        .allEventTrack({
                            category: "alle_page",
                            action: 'performance_load',
                            value: {
                                p_costTime: timing ? window.performance.timing.domContentLoadedEventEnd - window.performance.timing.fetchStart : -1,
                                costTime: Date.now() - window["_backendRequestFirstTime"]
                            },
                        })
                        .then((res) => {
                        })
                })


                //dns埋点
                this.allBridge
                    .allEventTrack({
                        category: "alle_page",
                        action: 'performance_dns',
                        value: {
                            p_costTime: timing ? timing.domainLookupEnd - timing.domainLookupStart : -1
                        },
                    })
                    .then((res) => {

                    })
                //tcp埋点
                this.allBridge
                    .allEventTrack({
                        category: "alle_page",
                        action: 'performance_tcp',
                        value: {
                            costTime: window["_backendResponseReadyTime"] - window["_backendRequestFirstTime"],
                            p_costTime: timing ? timing.connectEnd - timing.connectStart : -1
                        },
                    })
                    .then((res) => {
                    })
            }
        },
    },
    created() {
        if (this.$attrs['data-node-id'] === 'root') {
            this.$root.delayTime = this.delayTime
            this.website_trackFtp()
            this.$root.firstScreenNode = []
            this.website_getFirstScreenNode(this.pageInfo.child)
        }
        this.$emit('show', this.isShow)
        this.website_getSelfNode(this.pageInfo)
        this.website_getLoadTime()
    },
    methods: {
        website_trackFtp() {
            this.allBridge
                .allEventTrack({
                    category: "alle_page",
                    action: 'performance_fpt',
                    value: timing ? { timeCost: Date.now() - window["_backendRequestFirstTime"], p_timeCost: timing.domInteractive - timing.fetchStart }
                        : {
                            timeCost: Date.now() - window["_backendRequestFirstTime"],
                            p_costTime: -1
                        }
                })
                .then((res) => { })
        },
        website_getLoadTime() {
            let noContainerNodeArr = []
            this.$root.$on(this.$attrs['data-node-id'], (res) => {
                noContainerNodeArr.push(res)
                //  有任意子组件加载完成显示容器组件
                if (res.nt !== 'mc-baseContainer') {
                    setTimeout(() => {
                        this.isShow = true
                        this.$emit('show', this.isShow)
                    }, parseInt(this.delayTime))
                }
                if (
                    res.nt === 'mc-baseContainer' &&
                    this.$attrs['data-node-id'] === res.ni
                ) {
                    this.isShow = true
                    this.$emit('show', this.isShow)
                }
                //埋点上报数量等于子组件个数，上报埋点到根节点，并运算耗时

                if (noContainerNodeArr.length === this.childNum) {
                    this.Performance.push(
                        ...addParentCreatTime(noContainerNodeArr)
                    )
                    if (this.containerNum === 0 && this.$attrs['data-node-id'] !== 'root') {
                        this.website_findParentNode(
                            this.$parent && this.$parent.$parent
                        )
                    }
                }
            })
            this.$root.$on(this.$attrs['data-node-id'] + 'container', (res) => {
                this.Performance.push(...addParentCreatTime(res))
            })
   
            let addParentCreatTime = (array) => {
                this.$attrs['data-node-id']
                let containerLoadTime = noContainerNodeArr.find(
                    (item) => item.ni === this.$attrs['data-node-id']
                ).ct

                return array.map((item) => {
                    if (item.ni !== this.$attrs['data-node-id']) {
                        if (item.tct) {
                            item.tct = item.tct + containerLoadTime
                        } else {
                            item.tct = item.ct + containerLoadTime
                        }
                    } else {
                        item.tct = item.ct
                    }
                    return item
                })
            }
        },
        website_getSelfNode(node) {
            if (node.id === this.$attrs['data-node-id']) {
                this.website_getChildNum(node)
                this.website_getTotalChildNum(node)
              
            } else if (node.child) {
                node.child.forEach((item) => {
                    if (item.child && item.child.length > 0) {
                        this.website_getSelfNode(item)
                    }
                })
            }
        },
        website_getChildNum(node) {
            node.child.forEach((item) => {
                if (item.type !== 'mc-baseContainer') {
                    ++this.childNum
                    if (item.child && item.child.length > 0) {
                        this.website_getChildNum(item)
                    }
                } else {
                    ++this.containerNum
                }
            })
        },
        website_getTotalChildNum(node) {
            node.child.forEach((item) => {
                ++this.totalChildNum
                if (item.child && item.child.length > 0) {
                    this.website_getTotalChildNum(item)
                }
            })
        },
        website_findParentNode(node) {
            this.website_addDeep()
            if (node.nodeInfo && node.nodeInfo.type === 'mc-baseContainer') {
                this.$root.$emit(
                    node.nodeInfo.id + 'container',
                    this.Performance
                )
            } else if (node.$parent) {
                this.website_findParentNode(node.$parent)
            }
        },
        website_addDeep() {
            this.Performance.forEach((item) => {
                item.d = item.d + 1
                return item
            })
        },
        website_getFirstScreenNode(nodeArr) {
            nodeArr.forEach(item => {
                if (item.type !== 'mc-baseContainer' && this.$root.firstScreenNode.length < 2) {
                    this.$root.firstScreenNode.push(item.id)
                } else if (item.child && item.child.length !== 0 && this.$root.firstScreenNode.length < 2) {
                    this.website_getFirstScreenNode(item.child)
                }
            })
        }
    }
}